export default __webpack_public_path__ + "static/media/bg-priority.505be8e0.png";